import moment from "moment";

export const bodyTemplate = (data, props) => {
    return (
        <>
            <span className="p-column-title">{props.header}</span>
            {data[props.field]}
        </>
    );
};

export const dateTemplate = (data, props) => {
    return (
        <>
            <span className="p-column-title">{props.header}</span>
            {data[props.field]
                ? moment(data[props.field]).format("DD/MM/YYYY")
                : "-"}
        </>
    );
};

export const mandatoryTemplate = (data, props) => {
    return (
        <>
            <span className="p-column-title">{props.header}</span>
            {data[props.field]}
            {data?.is_mandatory === "Yes" ? (
                <span className="p-error">*</span>
            ) : (
                ""
            )}
        </>
    );
};

export const mandatoryTemplateForDocuments = (data, options, user) => {
    // SECURITY: Removed console.log to prevent information disclosure
    // console.log("user",user);
    if (
        data.documentName ===
            "Government Employees- Appointment Letter/ ID Card" &&
        user?.currentlyWorking
    ) {
        return (
            <>
                <span className="p-column-title">
                    {options.column.props.header}
                </span>
                {data[options.field]}
                {<span className="p-error">*</span>}
                {/* Example of using user */}
            </>
        );
    } else {
        return (
            <>
                <span className="p-column-title">
                    {options.column.props.header}
                </span>
                {data[options.field]}
                {data?.is_mandatory === "Yes" && (
                    <span className="p-error">*</span>
                )}
                {/* Example of using user */}
            </>
        );
    }
};

export const pdfTemplate = (data, header, pathName) => {
    return (
        <>
            <span className="p-column-title">{header}</span>
            {data?.fileName ? (
                <a
                    target="_blank"
                    href={`${process.env.REACT_APP_API_BASE_URL}/${pathName}/${data?.fileName}`}
                >
                    View File
                </a>
            ) : (
                "-"
            )}
        </>
    );
};
